export default "__VITE_ASSET__B2VvF6PU__"